"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var system_1 = require("@mui/system");
var material_1 = require("@mui/material");
var ProgressBar = function (_a) {
    var completedPercentage = _a.completedPercentage;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(system_1.Box, __assign({ sx: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    transition: 'transform .3s ease-out',
                    transform: "translateX(-".concat(100 - completedPercentage, "%)"),
                } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "column", sx: {
                        zIndex: 9999,
                        marginRight: '-2.4rem',
                        width: 'max-content',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        marginBottom: '0.4rem',
                    } }, { children: [(0, jsx_runtime_1.jsx)(system_1.Box, __assign({ sx: {
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignContent: 'center',
                                textAlign: 'center',
                                height: '7.2rem',
                                width: '7.2rem',
                                backgroundColor: 'common.white',
                                borderRadius: 9999,
                            } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ variant: "headlineMedium", sx: { color: 'primary.600', fontWeight: 'bold' } }, { children: [completedPercentage, (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: "span", variant: "bodySmall", sx: { color: 'primary.600', fontWeight: 'bold' } }, { children: "%" }))] })) })), (0, jsx_runtime_1.jsx)(system_1.Box, { sx: {
                                width: 0,
                                height: 0,
                                borderLeft: '1.5rem solid transparent',
                                borderRight: '1.5rem solid transparent',
                                borderTop: '2rem solid white',
                                marginTop: '-0.8rem',
                            } })] })) })), (0, jsx_runtime_1.jsx)(material_1.LinearProgress, { variant: "determinate", value: completedPercentage, color: "secondary", sx: {
                    width: '100%',
                    height: '1.9rem',
                    backgroundColor: 'transparent',
                    '& .MuiLinearProgress-bar': {
                        borderTopRightRadius: '2rem',
                        borderBottomRightRadius: '2rem',
                    },
                } })] }));
};
exports.ProgressBar = ProgressBar;
